var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.recipe !== null
    ? _c(
        "div",
        { staticClass: "recipe-card" },
        [
          _c(
            "router-link",
            { attrs: { to: "/recipe/" + _vm.recipe.recipe_id } },
            [
              _vm.recipe.imageUrl
                ? _c("lazy-picture", {
                    staticClass: "recipe-thumbnail",
                    attrs: {
                      "lazy-src": _vm.recipe.imageUrl,
                      "blurred-preview-src": _vm.recipe.imagePlaceholderUrl,
                      width: 105,
                      height: 105,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "recipe-info-container" }, [
                _c("span", { staticClass: "recipe-title" }, [
                  _vm._v(_vm._s(_vm.recipe.name)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "recipe-info-container-bottom" }, [
                  _vm.formatDateTime(_vm.recipe.dateCreated) != null
                    ? _c("span", { staticClass: "recipe-info-date" }, [
                        _c("span", {
                          staticClass:
                            "icon-calendar-dark recipe-info-date-icon",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "recipe-date" }, [
                          _vm._v(
                            _vm._s(_vm.formatDateTime(_vm.recipe.dateCreated)) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipe.dateModified !== _vm.recipe.dateCreated &&
                  _vm.formatDateTime(_vm.recipe.dateModified) != null
                    ? _c("span", { staticClass: "recipe-info-date" }, [
                        _c("span", {
                          staticClass: "icon-rename recipe-info-date-icon",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "recipe-date" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatDateTime(_vm.recipe.dateModified)
                            ) + "\n                    "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }